const state = {
  lastLoadedTimestamp: 0,
  ethereumTrendingTokens: [],
  ethereumTokensRank: [],
  defaultList: []
};

export default state;
